import A11yDialog from 'a11y-dialog';

const defaultConfig = {
  classModalIsOpen: 'is-active',
  classModalIsOpenBody: 'has-modal',
  root: document.getElementById('root'),
  modalsRoot: document.getElementById('root-modals'),
  moveModalToBottom: true,
};

export default class Modal {
  constructor(element, config) {
    this.element = element;
    this.config = { ...defaultConfig, ...config };

    this.onShow = this.onShow.bind(this);
    this.onHide = this.onHide.bind(this);

    Modal.moveModalToBottom = Modal.moveModalToBottom.bind(this);
    Modal.lockBody = Modal.lockBody.bind(this);
    Modal.unlockBody = Modal.unlockBody.bind(this);

    this.init();

    return this;
  }

  onShow(el) {
    this.constructor.lockBody();
    el.classList.add(this.config.classModalIsOpen);
  }

  onHide(el) {
    this.constructor.unlockBody();
    el.classList.remove(this.config.classModalIsOpen);
  }

  init() {
    if (this.moveModalToBottom) {
      Modal.moveModalToBottom();
    }

    this.dialog = new A11yDialog(this.element, this.config.root);

    this.dialog.on('show', this.onShow);

    this.dialog.on('hide', this.onHide);
  }

  destroy() {
    this.dialog.destroy();
  }

  update() {
    this.destroy();
    this.init();
  }

  static moveModalToBottom(
    el = this.element,
    modalRoot = this.config.modalsRoot
  ) {
    modalRoot.appendChild(el);
  }

  static lockBody(
    className = this.config.classModalIsOpenBody,
    container = this.config.root
  ) {
    // store current scrollTop value
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    document.body.setAttribute('data-lock-scrolltop', scrollTop);

    // add locking styles to body
    document.body.style.height = '100%';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';

    // add locking styles to scrollTop
    if (container) {
      /* eslint-disable no-param-reassign */
      container.style.height = '100%';
      container.style.width = '100%';
      container.style.overflow = 'hidden';
      container.style.position = 'fixed';
      // scroll page-container to scrollTop position
      container.scrollTop = scrollTop;
      /* eslint-enable no-param-reassign */
    }

    // add modal class
    document.body.classList.add(className);

    // attempt to scroll top fixed position
    window.requestAnimationFrame(() => {
      window.scrollTo(0, scrollTop);
    });
  }

  static unlockBody(
    className = this.config.classModalIsOpenBody,
    container = this.config.root
  ) {
    const scrollTop = document.body.getAttribute('data-lock-scrolltop');

    // remove locking styles from body
    document.body.style.height = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    document.body.style.position = '';

    // add modal class
    document.body.classList.remove(className);

    // remove locking styles from page-container
    if (container) {
      /* eslint-disable no-param-reassign */
      container.style.height = '';
      container.style.width = '';
      container.style.overflow = '';
      container.style.position = '';
      /* eslint-enable no-param-reassign */
    }

    // set scroll position back
    window.requestAnimationFrame(() => {
      window.scrollTo(0, scrollTop);
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.static.js